import React from "react";
import "./legal.css";

export default class Terms extends React.Component {
  render() {
    return (
      <div className="legal-content container">
        <h2>TERMS OF SERVICE</h2>
        <hr />
        <h3 style={{ marginBottom: "20px" }}>HUMAN CAPITAL MEMBER PLATFORM</h3>
        <p style={{ marginBottom: "20px" }}>
          <span style={{ fontWeight: 100 }}>
            These Terms of Service for the Human Capital Member Platform govern
            your access to and use of the Human Capital Member Platform, so
            please read everything carefully. You shall be referred to as
            “Member”. This page explains the terms by which you may use the
            Member Platform and any other services or applications owned,
            controlled, or offered by Nav Talent, Inc., a Delaware corporation
            doing business as Human Capital (“Human Capital”). By accessing or
            using the Member Platform you signify that you have read,
            understood, and agree to be bound by these Terms of Service and the
            associated Privacy Policy (collectively, the “Agreement”).
          </span>
        </p>
        <p>&nbsp;</p>
        <ol>
          <li>
            <h3>MEMBER PLATFORM</h3>
            <ol>
              <li>
                Member Platform.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  This Agreement governs Member’s access to, and use of, of
                  Human Capital’s “Member Platform”, which means (a) access to
                  and use of Human Capital’s proprietary interface that provides
                  Members with access to potential employers (“Employers”, and
                  such interface, the “Member Platform”), and (b) any support,
                  maintenance, and training services that Human Capital provides
                  to Member with respect to the use of the Member Platform
                  (“Support Services”). Member shall not assign or allow any
                  other persons to access or use the Member Platform. The Member
                  Platform provides Member with tools and services to provision,
                  support, and manage the use of the Member Platform.
                </span>
              </li>
              <li>
                Potential Employers.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Each Member acknowledges and understands that not all
                  Employers listed on the Member Platform may be actual clients
                  of Human Capital, and may represent potential or desired
                  clients of Human Capital. Such potential clients are listed
                  only for purposes of gauging interest, and therefore, Human
                  Capital may not be able to place Members at such potential
                  employers. Neither Human Capital nor such potential client
                  represents any affiliation with each other whatsoever.
                </span>
              </li>
              <li>
                Access; License.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Subject to the terms and conditions of this Agreement, during
                  the Term, Human Capital may provide Member access to the
                  Member Platform. Human Capital grants Member a limited,
                  non-exclusive, non-transferable, revocable right to access the
                  Member Platform to do the following solely for the internal
                  purposes of locating and selecting potential Employers for
                  employment: (i) access the features and functions of the
                  Member Platform; and (ii) view, download, reproduce, and print
                  job and Employer content made available to Member through the
                  Member Platform.
                </span>
              </li>
              <li>
                Third Party Products.{" "}
                <span style={{ fontWeight: 100 }}>
                  The Member Platform may contain links and features that
                  connect to third party websites, products, or services (“Third
                  Party Products”). This Agreement is not binding upon such
                  third parties, and Human Capital does not endorse such third
                  parties. Human Capital is not responsible for the actions or
                  inactions of such third parties or the contents or performance
                  of any Third Party Product.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <h3>HUMAN CAPITAL RESPONSIBILITIES</h3>
            <ol>
              <li>
                Member Platform.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Subject to this Agreement, Human Capital will (a) provide
                  Member with access to and use of the Member Platform, (b)
                  provide the Member Platform in material conformance with the
                  terms and conditions of this Agreement, (c) use commercially
                  reasonable efforts to make the Member Platform available 24
                  hours a day, 7 days a week except for instances of scheduled
                  maintenance or downtime or unavailability caused by
                  circumstances outside of Human Capital’s reasonable control
                  (e.g., emergency downtime, force majeure and similar events),
                  and (d) provide the Member Platform in accordance with the
                  laws and government regulations applicable to the provisioning
                  of the Member Platform and to Human Capital’s business. Human
                  Capital is responsible for the performance of its employees
                  and contractors and their compliance with Human Capital’s
                  obligations under this Agreement. Human Capital may use
                  non-employee contractors, service providers, or agents for the
                  purpose of providing Member Platform hereunder.
                </span>
              </li>
              <li>
                Changes to Member Platform.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  From time-to-time during the Term, Human Capital may update or
                  change the features, functionality or other aspects of the
                  Member Platform, for example to: (a) maintain or enhance (i)
                  the quality or delivery of the Member Platform to its Members,
                  (ii) the competitive strength of or market for the Member
                  Platform, or (iii) the Member Platform’s efficiency or
                  performance; or (b) to comply with applicable law and
                  regulation. Human Capital will use reasonable efforts to
                  provide electronic notice to Member in advance of any such
                  updates or changes.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <h3>MEMBER RESPONSIBILITIES</h3>
            <ol>
              <li>
                Content.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  In order to make use of the Member Platform, Member and
                  Employers, and their respective users, may upload, create, or
                  input information, data, documentation, and other materials
                  (together, “Content”) into the Member Platform. Member has
                  sole responsibility for all Content which it stores in the
                  Member Platform, whether publicly posted or privately
                  transmitted by Member. Human Capital does not endorse,
                  support, represent, or guarantee the completeness,
                  truthfulness, accuracy, or reliability of any Content or
                  communications posted via the Member Platform or endorse any
                  opinions expressed via the Member Platform. If Member uses or
                  relies on any Content or materials posted via the Member
                  Platform or obtained by Human Capital through the Member
                  Platform, it is at Member’s own risk. Human Capital disclaims
                  all liability as regards any of Content, and will not be
                  liable for (i) any loss or damage of any kind incurred as a
                  result of the use of any Content in the Member Platform, (ii)
                  any losses, costs, or expenses resulting from the loss or
                  corruption of Content, and/or (iii) any third party claims
                  relating to Content. Member agrees not to upload Content to
                  the Member Platform that: (i) may create a risk of harm, loss,
                  physical or mental injury, emotional distress, death,
                  disability, disfigurement, or physical or mental illness to
                  Member or to any other person; (ii) may create a risk of any
                  other loss or damage to any person or property; (iii) seeks to
                  harm or exploit children by exposing them to inappropriate
                  content, asking for personally identifiable details or
                  otherwise; (iv) may constitute or contribute to a crime or
                  tort; (v) contains any information or content that we deem to
                  be unlawful, harmful, abusive, racially or ethnically
                  offensive, defamatory, infringing, invasive of personal
                  privacy or publicity rights, harassing, humiliating to other
                  people (publicly or otherwise), libelous, threatening,
                  profane, or otherwise objectionable; (vi) contains any
                  information or content that is illegal (including, without
                  limitation, the disclosure of insider information under
                  securities law or of another party’s trade secrets); (vii)
                  contains any information or content that Member does not have
                  a right to make available under any law or under contractual
                  or fiduciary relationships; or (viii) contains any information
                  or content that Member knows is not correct and current.
                  Member agrees that any Content that it posts does not and will
                  not violate third party rights of any kind, including, without
                  limitation, any intellectual property rights of third parties,
                  or rights of privacy. Human Capital reserves the right to
                  reject and/or remove any Content that it believes, in its sole
                  discretion, violates this Agreement.
                </span>
              </li>
              <li>
                Registration.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  In order to access and use the Member Platform, Member will
                  have a personal account (an “Account”) through the Member
                  Platform. Member will (a) provide accurate, truthful, current,
                  and complete information with respect to its Account; and (b)
                  maintain and promptly update all Account information. Member
                  is responsible for protecting and safeguarding any passwords,
                  user IDs, or other credentials and login information that have
                  been provided to Member or that are generated in connection
                  with Member’s Account. Member will use reasonable efforts to
                  prevent unauthorized access to, or use of, its Account. Member
                  will immediately notify Human Capital in writing of any
                  unauthorized use of the Account that comes to Member’s
                  attention.
                </span>
              </li>
              <li>
                Authorized Use.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member will use the Member Platform in accordance with the
                  terms and conditions of this Agreement, including any
                  applicable usage restrictions on subscription term and other
                  usage parameters for the Member Platform (collectively,
                  “Approved Use”). Member is permitted to access and use the
                  Member Platform solely for her or her personal employment
                  purposes and not for the benefit of any third party. Member
                  will use the Member Platform in accordance with all applicable
                  laws and government regulations.
                </span>
              </li>
              <li>
                Cooperation.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member’s cooperation is required in order for Human Capital to
                  efficiently and effectively provide services in the Member
                  Platform. Member agrees to comply with all of Human Capital's
                  reasonable requests made in connection with the provision of
                  Member Platform to Member. Human Capital will have no
                  liability for any delays, deficiencies, or failures that occur
                  in the performance of Member Platform as a result of (a)
                  delays due to unanticipated Member requests, (b) Member’s
                  failure to cooperate (including the cooperation of third
                  parties under Member’s control), or (c) Member’s breach of
                  this Agreement.
                </span>
              </li>
              <li>
                Other Third Party Products and Services.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member is responsible for obtaining and maintaining, at its
                  sole cost and expense, any devices, hardware, equipment, third
                  party software, and all internet browsers and connections
                  required to access or use the Member Platform as such
                  requirements are specified herein. Human Capital shall not be
                  responsible for the contents of any linked external websites.
                </span>
              </li>
              <li>
                Restrictions; Limitations.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Without limitation of the foregoing, Member will not: (a)
                  modify, disassemble, decompile, reverse engineer, or do
                  anything that might discover source code or bypass or
                  circumvent measures employed to prevent or limit access to any
                  part of the Member Platform; (b) use or access the Member
                  Platform to build a competitive product or service; (c) use
                  any data mining, robots, or similar data gathering or
                  extraction methods designed to scrape or extract data from the
                  Member Platform; (d) download (other than page caching) any
                  portion of or information contained within the Member Platform
                  other than as expressly permitted by Human Capital; (e)
                  perform or disclose any benchmarking or performance testing of
                  the Member Platform; (f) sell, license, rent, lease or assign
                  the Member Platform or distribute, display, host, disclose,
                  outsource or otherwise commercially exploit the Member
                  Platform as part of a product or service provided to any third
                  party; (g) use the Member Interface for any unlawful purposes
                  or for promotion of illegal activities; or (h) use the Member
                  Platform other than for its intended use. This list is not
                  exhaustive. Member agrees to comply with all local laws
                  regarding online conduct and acceptable content. Member may
                  access the Member Platform only through interfaces and
                  protocols provided or authorized by Human Capital and may not
                  copy, co-brand, frame or mirror any part or content of the
                  Member Platform.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <h3>OWNERSHIP RIGHTS</h3>
            <ol>
              <li>
                Content Ownership.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member retains full ownership of its Content, but Member
                  hereby grant Human Capital a worldwide, non-exclusive,
                  irrevocable, transferable, royalty-free license (with the
                  right to sublicense) for the Term (except as otherwise
                  specified herein), to use, copy, reproduce, process, adapt,
                  modify, publish, transmit, edit, translate, make derivatives,
                  display and distribute any and all Content in order to: (a)
                  provide the Member Platform to Member; (b) create, improve,
                  market, or provide support for Human Capital and its products,
                  processes, and/or services; (c) compile and/or aggregate
                  analytical or other usage patterns related to use of the
                  Member Platform; and (d) otherwise aggregate and analyze the
                  Content, provided that in the cases of (b)-(d) the Content is
                  used in a form that does not identify Member. This license
                  also includes the right to modify or adapt Content as part of
                  the Member Platform in order to transmit, display, or
                  distribute it over computer networks and in various media
                  and/or make changes to Content to conform and adapt that
                  Content to any requirements or limitations of any networks,
                  devices, services, or media. Member also extends these rights
                  to the third party services with whom Human Capital works to
                  provide the services contemplated hereunder. Member represents
                  and warrants that it has the rights and authority necessary to
                  grant the rights granted herein to any Content that it
                  submits, including all necessary rights to upload its Content
                  for use in accordance with this Agreement.
                </span>
              </li>
              <li>
                Ownership by Human Capital.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Human Capital owns and retains all right, title, and interest
                  in and to the Member Platform, any Human Capital software or
                  technology utilized, created, or reduced to practice in the
                  provision of the Member Platform, the Member Platform, and all
                  Intellectual Property Rights contained therein or related
                  thereto, including without limitation all copies,
                  translations, adaptations, modifications, derivations, and
                  enhancements thereof (the “Human Capital Materials”). Member
                  acknowledges that (a) no right or interest in the Human
                  Capital Materials is conveyed other than the limited licenses
                  granted herein, (b) the Human Capital Materials are protected
                  by copyright and other intellectual property laws, and (c) the
                  Human Capital Materials embody valuable confidential and
                  secret information of Human Capital or its licensors, the
                  development of which required the expenditure of considerable
                  time and money. Member will not take or encourage any action
                  during or after the Term that will in any way impair the
                  rights of Human Capital in and to the Human Capital Materials,
                  any proprietary software or technology of Human Capital, or
                  any Intellectual Property Rights in and to any of the
                  foregoing. “Intellectual Property Rights” means all patents,
                  copyrights, moral rights, trademarks, trade names, service
                  marks, trade dress, trade secrets and any other form of
                  intellectual property rights now or hereafter recognized in
                  any jurisdiction, including applications and registrations for
                  any of the foregoing.
                </span>
              </li>
              <li>
                Restrictions.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member will not: (a) alter, or permit the alteration of, the
                  Human Capital Materials, or any component thereof, (b) copy,
                  or permit the copying of, the Human Capital Materials or any
                  component thereof, (c) take any action that would foreseeably
                  jeopardize Human Capital’s or its licensors’ proprietary
                  rights in the Human Capital Materials, (d) seek to acquire any
                  ownership interest in or to the Human Capital Materials or any
                  component thereof, (e) attempt to derive source or object code
                  from the Human Capital Materials or any component thereof, (f)
                  access the Member Platform to build or create a derivative,
                  competitive, or similar product or service, or copy any ideas,
                  features, functions, or graphics of the Member Platform, or
                  (g) license, sell, transfer, lease, or disclose the Human
                  Capital Materials.
                </span>
              </li>
              <li>
                Feedback.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member may have the option to provide Human Capital with
                  feedback, suggestions, or comments regarding the Member
                  Platform. From time to time, Human Capital may request that
                  Member provide feedback in a specified form, manner and/or
                  frequency, provided that all such feedback will be at Member’s
                  discretion. Member hereby grants Human Capital a
                  non-exclusive, perpetual, and irrevocable license to use and
                  exploit such feedback for any purpose, including incorporating
                  such feedback within its products and services, without
                  providing payment or any other consideration to Member.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <h3>PUBLICITY.</h3>
            <p>
              Member agrees that the HC Parties may issue a press release or
              other promotional information upon successful completion of an
              engagement, referencing both Member and a placed Employer.
              Additionally, the HC Parties may publicly refer to Member as a
              Member of the company, including, without limitation, any verbal
              statements, written materials, or use of Member’s logo for
              purposes of, without limitation, marketing, pitchbooks, press
              interviews, promotional activities, fundraising activities,
              website marketing, and reference calls with prospective Members,
              clients of Human Capital (i.e., Employers), and employees.
            </p>
          </li>
          <li>
            <h3> NON-SOLICITATION.</h3>
            <p>
              During the Term (defined below) and for a period of one (1) year
              thereafter, Member agrees that it will not, without Human
              Capital’s written consent, directly or indirectly employ, solicit,
              engage, accept, or retain the services of any current or former
              personnel of Human Capital. In the event Member breaches this
              provision, it shall be liable to Human Capital for an amount (that
              Member agree is not to be construed as punitive but compensatory
              in nature) equal to one hundred percent (100%) of the annual
              compensation of the relevant personnel in his or her new position,
              plus all actual and reasonable fees and expenses incurred by Human
              Capital in hiring replacement personnel including but not limited
              to recruiters’ fees and reasonable attorneys’ fees incident
              thereto. For the avoidance of doubt, this Section 6 shall apply to
              each parent, and subsidiary, and affiliate of Human Capital.
            </p>
          </li>
          <li>
            <h3>TERM AND TERMINATION</h3>
            <ol>
              <li>
                Term.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Unless terminated earlier pursuant to any of the Agreement’s
                  express provisions, the term of this Agreement will commence
                  on the Effective Date and will continue until the earlier of
                  the date on which (i) Member is no longer seeking employment;
                  and (ii) Human Capital deems appropriate (“Term”). Human
                  Capital and Member may mutually agree on additional extension
                  periods thereafter.
                </span>
              </li>
              <li>
                Termination.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Either Party may immediately terminate this Agreement by
                  providing prior written notice of its intent to terminate. In
                  the event of any termination: (a) all of Member’s rights under
                  the Agreement will immediately terminate and Member will
                  immediately cease any access or use of the Member Platform;
                  and (b) Sections 4, 5, 6, 8, 9, 10.4, and 10.5 of this
                  Agreement, together with any other provisions that by their
                  nature are intended to survive, will continue to apply in
                  accordance with their terms.
                </span>
              </li>
              <li>
                Suspension, Limitation, or Termination.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Human Capital may, in its sole discretion, immediately stop,
                  suspend, or modify the Member Platform at any time without
                  prior notice, in any circumstances Human Capital reasonably
                  determine to be necessary, including but not limited: (i) if
                  Member violates a material restriction or obligation in the
                  Agreement; (ii) to perform essential repairs/maintenance to
                  the Service; or (iii) if in Human Capital’s judgment, the
                  Member Platform or any component thereof is about to suffer a
                  material threat to security or functionality. Human Capital
                  will use reasonable efforts to re-establish Member Platform
                  promptly after Human Capital determines, in its reasonable
                  discretion, that the situation giving rise to the suspension
                  has been cured. Human Capital may terminate Member Platform if
                  any of the foregoing causes of suspension are not cured within
                  30 days after Human Capital’s initial notice thereof.
                </span>
              </li>
            </ol>
          </li>
          <li>
            <h3>PRIVACY; DATA PROTECTION.</h3>
            <p>
              Human Capital may collect, use, and share personally identifiable
              information and non-personally identifiable information as
              described in our{" "}
              <a href="/privacy" target="_blank">
                Privacy Policy
              </a>
              . Each Party shall comply with its obligations under applicable
              data protection regulations regarding its activities under this
              Agreement. Member (as data controller) is responsible for
              assessing data collection legitimacy, processing, and use of the
              protection of Employer’s rights. To the extent that Human Capital
              (as data processor) processes personal data disclosed by Member,
              Human Capital will act only on instructions from Member regarding
              processing of that personal data.
            </p>
          </li>
          <li>
            <h3>LIABILITY</h3>
            <p>
              Member is solely responsible for determining whether and on which
              terms to choose certain Employers and for its employment
              decisions. Member assumes all risks arising from Member’s
              employment activities and decisions. Member releases and agrees to
              defend, indemnify, and hold Human Capital harmless from and
              against all third party claims asserted against Human Capital in
              connection with this Agreement and any judgment or liability
              imposed against Human Capital pursuant to such claims. TO THE
              FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE MEMBER PLATFORM
              ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, AND MEMBER
              HEREBY WAIVES, RELEASES, AND DISCLAIMS, ALL OTHER WARRANTIES OF
              ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE
              REGARDING THE MEMBER PLATFORM OR RESULT INCLUDING ANY WARRANTY
              THAT THE MEMBER PLATFORM OR RESULT WILL BE UNINTERRUPTED, ERROR
              FREE OR FREE OF HARMFUL COMPONENTS, OR THAT ANY MATERIALS OR DATA
              PROVIDED BY MEMBER OR A THIRD PARTY WILL BE SECURE OR NOT
              OTHERWISE LOST OR DAMAGED. EXCEPT TO THE EXTENT PROHIBITED BY LAW,
              HUMAN CAPITAL AND ITS SUPPLIERS DISCLAIM ALL WARRANTIES, INCLUDING
              ANY IMPLIED WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY,
              FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR QUIET
              ENJOYMENT, AND ANY WARRANTIES ARISING OUT OF ANY COURSE OF DEALING
              OR USAGE OF TRADE. TO THE MAXIMUM EXTENT PERMITTED UNDER
              APPLICABLE LAW, (A) NEITHER PARTY WILL BE LIABLE (WHETHER IN
              CONTRACT OR IN TORT) UNDER ANY CIRCUMSTANCES FOR ANY INDIRECT,
              CONSEQUENTIAL (INCLUDING LOST OPPORTUNITIES OR PROFITS), OR
              PUNITIVE DAMAGES, EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES, AND (B) THE AGGREGATE LIABILITY OF
              EACH PARTY ARISING FROM OR RELATING TO THIS AGREEMENT, WHETHER IN
              CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE), WILL NOT EXCEED
              AN AMOUNT EQUAL TO US$1,000. THE ABOVE DISCLAIMERS AND LIMITATIONS
              OF LIABILITY SHALL NOT APPLY TO ANY DAMAGES ARISING FROM (I)
              EITHER PARTY’S BREACH OF ANY CONFIDENTIALITY TERMS SET FORTH
              HEREIN, (II) AMOUNTS OWED PURSUANT TO EITHER PARTY’S
              INDEMNIFICATION OBLIGATIONS HEREUNDER, (III) EITHER PARTY’S BREACH
              OF ANY INTELLECTUAL PROPERTY TERMS SET FORTH HEREIN, OR (IV)
              EITHER PARTY’S GROSS NEGLIGENCE, WILLFUL MISCONDUCT, OR FRAUD.
            </p>
          </li>

          <li>
            <h3>MISCELLANEOUS</h3>

            <ol>
              <li>
                Independent Contractor.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  This Agreement does not create any agency, partnership, or
                  joint venture between the Parties. This Agreement does not
                  create any third party beneficiary rights in any individual or
                  entity that is not a Party to this Agreement unless it
                  expressly states that it does.
                </span>
              </li>
              <li>
                Assignment.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Neither Party may assign or transfer this Agreement or any of
                  its rights or obligations hereunder without the other Party’s
                  prior written consent, provided that Human Capital may assign
                  this Agreement to an affiliate under common control without
                  the Member’s consent. This Agreement is binding upon and
                  inures to the benefit of the Parties and their respective
                  successors and permitted assigns.
                </span>
              </li>
              <li>
                Force Majeure.{" "}
                <span style={{ fontWeight: 100 }}>
                  Neither Party will be liable for, or be considered to be in,
                  breach of or default under this Agreement on account of any
                  delay or failure to perform as required by this Agreement as a
                  result of any cause or condition beyond such Party’s
                  reasonable control (including, without limitation, any act or
                  failure to act by the other Party).
                </span>{" "}
              </li>
              <li>
                Governing Law; Enforcement.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  This Agreement shall be governed by and construed in
                  accordance with the laws of the State of California, without
                  regard to principles of conflicts of law. In the event that
                  Human Capital initiates litigation to enforce its rights under
                  this Agreement and is the prevailing Party in such litigation,
                  Human Capital shall be entitled to costs of suit and
                  reasonable attorney fees incurred by it in connection with
                  such litigation. Member acknowledge that monetary damages
                  would not be an adequate remedy for any breach of Section 4
                  and that Human Capital may, in addition to all other remedies
                  available at law or in equity, obtain immediate injunctive or
                  other equitable relief, without the necessity of posting bond
                  or other security, to remedy or prevent any breach or
                  threatened breach of such section.
                </span>
              </li>
              <li>
                Information.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Member acknowledges and agrees that the HC Parties operate
                  within a larger organizational structure and information
                  learned from or about Member may be shared within the
                  organization between the HC Parties, namely with TCM Group
                  Holdings, LLC dba Human Capital Management, an affiliate
                  investment management firm.
                </span>
              </li>
              <li>
                Agreement Modification.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Human Capital may revise this Agreement at any time without
                  notice. By using the Member Interface, Member is agreeing to
                  be bound by the then-current version of this Agreement.
                  Continued use of the Member Interface following notice of such
                  changes will indicate Member’s acknowledgement of such changes
                  and agreement to be bound by the terms and conditions of such
                  changes. Member is responsible for providing Human Capital
                  with its most current e-mail address. In the event that the
                  last e-mail address that Member has provided Human Capital is
                  not valid, or for any reason is not capable of delivering to
                  Human Capital any related notice, its dispatch of the e-mail
                  containing such notice will nonetheless constitute effective
                  notice of the changes described in the notice.
                </span>
              </li>
              <li>
                Entire Agreement.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  This Agreement constitutes the complete and exclusive
                  statement of all mutual understandings between the Parties
                  with respect to the subject matter hereof, superseding all
                  prior or contemporaneous proposals, communications and
                  understandings, oral or written. Any preprinted terms
                  appearing in any other documents that differ from, are
                  inconsistent with, or are in addition to the terms of this
                  Agreement, shall be void. Section headings contained in this
                  Agreement are inserted only for convenience of reference, and
                  shall not be construed as a part of this Agreement or as
                  altering or affecting in any way the meaning or interpretation
                  of any term or provision hereof. If any provision or part of a
                  provision of this Agreement is determined to be illegal,
                  invalid, or unenforceable, the validity of the remaining
                  provisions will not be affected and will be enforced to the
                  fullest extent of applicable law. Neither Party will be
                  treated as having waived any rights by not exercising (or
                  delaying the exercise of) any rights under this Agreement.
                  Each Party has reviewed this Agreement carefully and has had
                  the opportunity to consult counsel; accordingly, the principle
                  of construction that any ambiguities are to be resolved
                  against the drafting Party will not be employed in the
                  interpretation of this Agreement.
                </span>
              </li>
              <li>
                Notices.
                <span style={{ fontWeight: 100 }}>
                  {" "}
                  Notices under this Agreement are sufficient if given in
                  writing and in English to: (a) in the case of notices to
                  Member, Member’s email or postal address set out in his or her
                  member profile; and (b) in the case of notices to Human
                  Capital, to ba@human.capital and aa@human.capital, or as
                  otherwise notified to Member. Notice will be treated as given
                  on receipt, as verified by written or automated receipt or by
                  electronic log (as applicable).
                </span>
              </li>
            </ol>
          </li>
        </ol>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Legal/Terms.js